// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"832":"2a16730ed108114a","3996":"e6e1c05b79fa9f65","4005":"747b7a754541d5d0"}[chunkId] + ".css";
};